import { useQuery } from 'react-query';

import { applianceQueryKeys } from '../QueryKeys';
import useApiHelper from '../../hooks/useApiHelper';
import { IApplianceSelection } from '../../types/Appliance/Appliance';
import { IDefaultResponseWithData } from '../../types/system/DefaultResponse';

export default function useSuperAdminApplianceTypes() {
  const { get } = useApiHelper();

  const superAdminApplianceTypes = useQuery({
    queryKey: applianceQueryKeys.superAdminTypes(),
    queryFn: () =>
      get<IDefaultResponseWithData<IApplianceSelection>>(
        `/v1/superadmin/hardware/types`
      ).then((res) => res.data.data),
  });

  return {
    superAdminApplianceTypes,
  };
}
